//external
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { deleteDonorSpecie, getDonorSpecie } from 'services/donorSpecie/service';
import history from 'services/history';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
//style
import { Attr, AttrName } from './styled';
import { Button, ButtonContainer } from 'styles/components';

export default function ComponentGroupDelete({match}) {
  const donorSpecieId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [donorSpecie, setComponentGroup] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (donorSpecieId) {
      dispatch(startRequest());
      getDonorSpecie(donorSpecieId).then(data => {
        setComponentGroup(data.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, donorSpecieId]);

  async function handleDelete () {
    dispatch(startRequest());
    deleteDonorSpecie(donorSpecieId).then(data => {
      history.push('/premixLabel/donor_specie')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir esta espécie de doador?" message={message}>
        {donorSpecie && <>
          <AttrName>Descrição:</AttrName>
          <Attr>{donorSpecie.description}</Attr>
          <AttrName>Número de Referência:</AttrName>
          <Attr>{donorSpecie.referenceNumber}</Attr>
          <AttrName>Texto:</AttrName>
          <Attr>{donorSpecie.text}</Attr>
          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}